import { render, staticRenderFns } from "./print-settings.vue?vue&type=template&id=b122b716&scoped=true&"
import script from "./print-settings.vue?vue&type=script&lang=js&"
export * from "./print-settings.vue?vue&type=script&lang=js&"
import style0 from "./print-settings.vue?vue&type=style&index=0&id=b122b716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b122b716",
  null
  
)

export default component.exports